import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";
import Vue from "vue";
import {AuthService} from "@/services/auth-service";

export const CashierService = new Vue({
	data() {
		return {

		};
	},
	computed: {
		url(): string {
			return `${ServerConfig.host}/cashier`;
		}
	},
	methods: {
		async openDisplay(uuid:string,id:number) {
			await Axios.post(`${this.url}/open-display/`+ AuthService.wfDossier.id +`/`+uuid+`/`+id);
		},
		async clearDisplay(uuid:string) {
			await Axios.post(`${this.url}/clear-display/`+ AuthService.wfDossier.id +`/`+uuid);
		},

	},
	async created() {
		requestAnimationFrame(() => {


		});
	}
});